import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { dateOnly, price } from "@/lib/format";

export default function AccountOrders() {
  const { data, loading } = useFetch("/account/orders");
  const items = data?.items || [];
  return (
    <div data-testid="account-orders">
      <h2 className="font-display text-3xl">Orders</h2>
      <p className="text-sm text-muted-foreground mt-2">Your order history will appear here once online checkout is enabled.</p>
      {loading && <p className="text-sm text-muted-foreground mt-6">Loading…</p>}
      {!loading && items.length === 0 && (
        <div className="mt-8 bg-white border rounded-lg p-12 text-center" data-testid="orders-empty">
          <Package className="h-10 w-10 mx-auto text-muted-foreground" strokeWidth={1.1} />
          <p className="font-display text-2xl mt-5">No orders yet</p>
          <p className="text-sm text-muted-foreground mt-2">Add favourites to your bag today and come back when checkout opens.</p>
          <Link to="/new-arrivals" className="btn-ghost-lux mt-6 inline-flex" data-testid="orders-empty-shop">Explore new arrivals</Link>
        </div>
      )}
      {items.length > 0 && (
        <ul className="mt-6 space-y-3" data-testid="orders-list">
          {items.map((o) => (
            <li key={o.id} className="bg-white border rounded-lg p-5 flex items-center justify-between" data-testid={`order-row-${o.id}`}>
              <div><p className="font-display text-xl">{o.order_number || o.id}</p><p className="text-xs text-muted-foreground mt-1">{dateOnly(o.created_at)} · {o.status}</p></div>
              <div className="text-right"><p className="text-sm tabular font-semibold">{price(o.total)}</p></div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
